import { useContext } from 'react'
import styles from './App.module.css'
import { ProductDataContextProvider } from './Context/Product/ProductDataContext'
import { UserContext } from './Context/User/UserContext'
import { WholeAppLayout } from './Layouts/WholeAppLayout/WholeAppLayout'
import { useAxiosInterceptors } from './service/HTTP/useAxiosInterceptors'
import { LoginPage } from './containers/LoginPage/LoginPage'
import { useCheckToken } from './hooks/useCheckToken'
import { RecoverPasswordModal } from './components/RecoverPasswordModal/RecoverPasswordModal'
import { ResetPasswordModal } from './components/ResetPasswordModal/ResetPasswordModal'

export const App = (): JSX.Element => {
  const { isUserLoggedIn } = useContext(UserContext)
  useAxiosInterceptors()
  useCheckToken()

  const searchParams = new URLSearchParams(window.location.search)
  const token = searchParams.get('token')
  const type = searchParams.get('type')

  const contentToRender = (): JSX.Element => {
    if (token && type === 'recovery')
      return <RecoverPasswordModal token={token} />
    if (token && type === 'reset') return <ResetPasswordModal token={token} />
    if (!isUserLoggedIn()) return <LoginPage />
    return (
      <ProductDataContextProvider>
        <main className={styles.App}>
          <WholeAppLayout />
        </main>
      </ProductDataContextProvider>
    )
  }

  return contentToRender()
}
